import {
  DbacksTCLanguage,
  DbacksHamburgerTCListItems,
} from "../../tc_helper_dbacks";
import { routes } from "@/global/routes";
import { vendorUUIDs } from "../../constants";
import { faqs, howItWorks, AnalyticsHeader } from "./helpers";

import type { TeamConfig } from "../types";

import BackgroundImage from "public/images/diamondbacks/dbacks_bg.jpeg";
import SeatMap3dPreview from "public/images/diamondbacks/seat_map_preview.png";

const LogoImage = "https://ss-leagues.s3.amazonaws.com/MLB-3/AZD-UPDATED.png";
const BannerImage =
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/MK05-10251389%20Web%20-%202026%20Attend%20Site%20Specs-1486x148_Mini%20Plans%20BOGO.jpg";

const config: TeamConfig = {
  teamSchema: "dbacks_miniplanscomp",
  browserTitle: "Arizona Diamondbacks",
  packages: false,
  defaultRoute: routes.purchaseSeats,
  phoneNumber: "",
  mlbTeamId: 109,
  teamName: "Arizona Diamondbacks",

  // seat map configs
  seatMapConfigs: {
    venueId: "nam-us-10167-diamondbacks-sec",
    mapId: "blockmap2d",
  },

  // gift cards
  giftCardConfigs: {
    isMenuGiftCardEnabled: false,
    isLandingPageGiftCardEnabled: false,
    isStandalonePageGiftCardEnabled: false,
    redirectGiftCardUrl: routes.redeem,
  },

  // purchase credit configs
  purchaseCreditConfigs: {
    isLandingPurchaseCreditEnabled: false,
    isStandAlonePurchaseCreditEnabled: false,
    showPurchaseCreditLinkInHomeMenu: false,
    isPurchaseCreditHistoryEnabled: false,
  },

  // disabled routes
  disabledRoutes: [routes.giftCard],

  // switches
  checkoutCreditPackages: false,
  availableCreditEnabled: false,
  isCrowdHandlerEnabled: false,
  inventoryType: "SEAT-LEVEL",

  // purchase seats config
  purchaseSeatConfigs: {
    minGameSelectionCount: 4,
    minSeatLimit: 1,
    isSimilarSeatForAllEvents: true,
    allowManualCartInSimilar: false,
    isCheckoutEditSeatsEnabled: false,
    isDiffSeatAlertEnabled: false,
    isPerksEnabled: true,
    hideViewTicketsInThankYouPage: true,
  },

  // feature configs
  packageConfigs: {
    isPackageEnabled: false,
    canRemovePackageGames: false,
    staticBuildYourOwn: null,
  },

  // intercom settings
  intercomConfigs: {
    isIntercomEnabled: true,
    allowedPages: [],
  },

  // checkout validations
  checkoutValidation: {
    allowedZipFailCount: Infinity,
    allowedPaymentFailCount: Infinity,
  },

  isSaveCardAllowed: true,
  oktaClientId: "",
  oktaIssuer: "",
  refreshInventoryWhenEventClick: false,
  platform: vendorUUIDs.ticketmaster,

  // analytics configs
  analyticsConfigs: {
    googleAnalyticsId: "",
    attrkPixelId: "",
    beaconId: "",
    AnalyticsHeader,
  },

  // redirect configs
  redirectConfigs: {
    internalRedirectUrl: "",
    externalRedirectUrl: "",
  },

  // urls
  accountManagerUrl: "https://am.ticketmaster.com/azdbacks/",

  // images
  images: {
    logoNameImage: "",
    faviconImage: LogoImage,
    findGamesBannerImage: BannerImage,
    authBackgroundImage: BackgroundImage.src,
    giftCardStandalonePageImage: BannerImage,
    seatMap3dPreviewImage: SeatMap3dPreview.src,
    logoImage: LogoImage + "?width=84&height=66",
    checkoutStatusPageImage: BackgroundImage.src,
  },

  uiConfigs: {
    bannerImage: {
      title: "",
      isBackgroundBasedBanner: false,
    },

    featuredGameCard: {
      showLogoWithTitle: true,
      hideOverlayLogo: true,
    },

    bottomBar: {
      showGameSelectionProgress: true,
    },

    checkoutPerkSubtotals: {
      perkTotalLabel: "Add-Ons Total",
    },

    purchaseHistory: {
      hideAccessTicketButton: true,
    },

    authPage: {
      showHamburgerMenuButton: true,
    },
  },

  colors: {
    primary: "#AA182C",
  },

  howItWorks: howItWorks,
  faqs: faqs,

  languages: {
    topNavMenuItems: <DbacksHamburgerTCListItems />,
    checkoutTermsAndCondition: <DbacksTCLanguage />,
    registrationTermsAndCondition: <DbacksTCLanguage />,
    purchaseSeats: null,
    purchaseGiftCard: null,
    redeemGiftCard: null,
    purchaseCredit: null,

    checkoutSuccessMessage: "Your purchase is complete!",
    checkoutSuccessDescription: "Your Arizona Diamondbacks are confirmed!",

    giftCard: {
      title: "",
      createGiftCard: {
        description: "",
        recipient: {
          sendNowFalse: {
            description: "",
          },
          sendNowTrue: {
            description: "",
          },
        },
      },
      redeemGiftCard: {
        loggedIn: {
          description: "",
        },
        logout: {
          description: "",
        },
        success: {
          description: "",
        },
      },
    },

    signInAuthText:
      "Connect your Ticketmaster account to continue with seamless access.",
  },
};

export default config;
